module.exports = __webpack_public_path__ + "img/198.2e80c664.jpg";